<template>
    <el-dialog
        v-if="visible"
        :visible="visible"
        :show-close="false"
        width="660px"
        :close-on-click-modal="false"
    >
        <div class="dialog">
            <dialogHeader
                :title="actionType == 'add' ? '新增商户转账配置' : '编辑商户转账配置'"
                @closeDialog="onClose"
            ></dialogHeader>
            <div class="dialogList">
                <el-form
                    :rules="rules"
                    ref="dialogForm"
                    :model="dialogForm"
                    label-width="145px"
                >
                    <el-form-item
                        label="供应商"
                        prop="member_id"
                        v-if="actionType == 'add'"
                    >
                        <el-select
                            v-model="memberType"
                            placeholder="请选择"
                            style="width: 120px"
                            size="small"
                        >
                            <el-option
                                v-for="item in memberTypeList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                        <el-select
                            size="small"
                            v-model="dialogForm.member_id"
                            filterable
                            remote
                            reserve-keyword
                            :placeholder="`请输入${memberTypeList[memberType].label}搜索用户`"
                            :remote-method="remoteMethod"
                            :loading="selectLoading"
                            style="width: 265px"
                        >
                            <el-option
                                v-for="item in memberList"
                                :key="item.id"
                                :label="item.dname"
                                :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="模式选择">
                        <el-radio-group v-model="mode" @change="onModeChange" size="small">
                            <el-radio-button :label="0">表单</el-radio-button>
                            <el-radio-button :label="1">代码</el-radio-button>
                        </el-radio-group>
                    </el-form-item>
                    <!-- 表单模式 -->
                    <template v-if="mode === 0">
                        <el-form-item label="开发者ID" prop="appid">
                            <el-input
                                size="small"
                                v-model.trim="dialogForm.appid"
                                placeholder="微信开放平台APPID"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="商户号" prop="mchid">
                            <el-input
                                size="small"
                                v-model.trim="dialogForm.mchid"
                                placeholder="微信支付商户号"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="商户API证书序列号" prop="v3SerialNO">
                            <el-input
                                size="small"
                                v-model.trim="dialogForm.v3SerialNO"
                                placeholder="商户API证书序列号"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="微信支付公钥ID" prop="wp_serial">
                            <el-input
                                size="small"
                                v-model.trim="dialogForm.wp_serial"
                                placeholder="PUB_KEY_ID开头"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="APIv3密钥" prop="v3ApiKey">
                            <el-input
                                size="small"
                                v-model.trim="dialogForm.v3ApiKey"
                                placeholder="自己设置的32位随机字符串"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="商户API证书" prop="v3PrivateKeyPem">
                            <el-input
                                size="small"
                                type="textarea"
                                :autosize="{ minRows: 3, maxRows: 6 }"
                                v-model.trim="dialogForm.v3PrivateKeyPem"
                                placeholder="商户API证书(v3)PEM内容"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="商户API证书路径(非必填)">
                            <el-input
                                size="small"
                                v-model.trim="dialogForm.v3PrivateKeyPath"
                                placeholder="旧版商户API证书文件路径"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="微信支付公钥" prop="v3PublicKeyPem">
                            <el-input
                                size="small"
                                type="textarea"
                                :autosize="{ minRows: 3, maxRows: 6 }"
                                v-model.trim="dialogForm.v3PublicKeyPem"
                                placeholder="微信支付公钥PEM内容"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="微信支付公钥路径(非必填)">
                            <el-input
                                size="small"
                                v-model.trim="dialogForm.v3PublicKeyPemPath"
                                placeholder="旧版微信支付公钥文件路径"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="旧版微信平台证书路径">
                            <el-input
                                size="small"
                                v-model.trim="dialogForm.v3PlatformCertificatePath"
                                placeholder="旧版微信平台证书文件路径"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="旧版微信平台证书内容">
                            <el-input
                                size="small"
                                type="textarea"
                                :autosize="{ minRows: 3, maxRows: 6 }"
                                v-model.trim="dialogForm.v3PlatformCertificatePem"
                                placeholder="旧版微信平台证书PEM内容"
                            ></el-input>
                        </el-form-item>
                    </template>
                    <!-- 代码模式 -->
                    <el-form-item v-else label="配置JSON" prop="jsonInput">
                        <el-input
                            size="small"
                            type="textarea"
                            :autosize="{ minRows: 8, maxRows: 16 }"
                            v-model.trim="dialogForm.jsonInput"
                            placeholder='粘贴JSON配置，如: {"appid":"wx...","mchid":"...","v3SerialNO":"...","wp_serial":"PUB_KEY_ID_...","v3ApiKey":"...","v3PrivateKeyPem":"...","v3PublicKeyPem":"..."}'
                        ></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div
                slot="footer"
                class="dialog-footer"
                flex="cross:center main:right"
            >
                <el-button size="small" @click="onClose">取 消</el-button>
                <el-button
                    size="small"
                    type="primary"
                    :loading="addLoading"
                    @click="onSubmit('dialogForm')"
                >
                    确 定
                </el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import { queryMemberByCondition } from "@/api/admin";
import {
    addTransferMerchantConf,
    updateTransferMerchantConf,
} from "@/api/config";

export default {
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        actionType: {
            type: String,
            default: "add",
        },
        configData: {
            type: Object,
            default: null,
        },
    },
    data() {
        const validateJsonInput = (rule, value, callback) => {
            if (!value) {
                callback(new Error("配置JSON不能为空"));
                return;
            }
            try {
                const obj = JSON.parse(value);
                if (typeof obj !== "object" || Array.isArray(obj)) {
                    callback(new Error("请输入有效的JSON对象"));
                    return;
                }
                callback();
            } catch (e) {
                callback(new Error("JSON格式错误: " + e.message));
            }
        };
        return {
            rules: {
                member_id: [
                    {
                        required: true,
                        message: "供应商不能为空",
                        trigger: "blur",
                    },
                ],
                appid: [
                    {
                        required: true,
                        message: "开发者ID不能为空",
                        trigger: "blur",
                    },
                ],
                mchid: [
                    {
                        required: true,
                        message: "商户号不能为空",
                        trigger: "blur",
                    },
                ],
                v3SerialNO: [
                    {
                        required: true,
                        message: "商户API证书序列号不能为空",
                        trigger: "blur",
                    },
                ],
                wp_serial: [
                    {
                        required: true,
                        message: "微信支付公钥ID不能为空",
                        trigger: "blur",
                    },
                ],
                v3ApiKey: [
                    {
                        required: true,
                        message: "APIv3密钥不能为空",
                        trigger: "blur",
                    },
                ],
                jsonInput: [{ validator: validateJsonInput, trigger: "blur" }],
            },
            mode: 0, // 0=表单, 1=代码
            dialogForm: {
                id: "",
                member_id: "",
                appid: "",
                mchid: "",
                v3SerialNO: "",
                wp_serial: "",
                v3ApiKey: "",
                v3PrivateKeyPem: "",
                v3PrivateKeyPath: "",
                v3PublicKeyPem: "",
                v3PublicKeyPemPath: "",
                v3PlatformCertificatePath: "",
                v3PlatformCertificatePem: "",
                jsonInput: "",
            },
            selectLoading: false,
            memberTypeList: [
                { value: 0, label: "账号" },
                { value: 1, label: "手机号" },
                { value: 2, label: "名称" },
            ],
            memberType: 0,
            memberList: [],
            addLoading: false,
        };
    },
    watch: {
        visible(val) {
            if (val) {
                if (
                    this.actionType === "edit" &&
                    this.configData
                ) {
                    this.fillFormFromConfig(this.configData);
                }
            } else {
                this.resetForm();
            }
        },
    },
    methods: {
        fillFormFromConfig(data) {
            let detailObj = {};
            try {
                detailObj =
                    typeof data.detail_config === "string"
                        ? JSON.parse(data.detail_config)
                        : data.detail_config || {};
            } catch (e) {
                detailObj = {};
            }
            this.dialogForm = {
                id: data.id || "",
                member_id: data.member_id || "",
                appid: detailObj.appid || "",
                mchid: detailObj.mchid || "",
                v3SerialNO: detailObj.v3SerialNO || "",
                wp_serial: detailObj.wp_serial || data.wp_serial || "",
                v3ApiKey: detailObj.v3ApiKey || "",
                v3PrivateKeyPem: detailObj.v3PrivateKeyPem || "",
                v3PrivateKeyPath: detailObj.v3PrivateKeyPath || "",
                v3PublicKeyPem: detailObj.v3PublicKeyPem || "",
                v3PublicKeyPemPath: detailObj.v3PublicKeyPemPath || "",
                v3PlatformCertificatePath: detailObj.v3PlatformCertificatePath || "",
                v3PlatformCertificatePem: detailObj.v3PlatformCertificatePem || "",
                jsonInput: JSON.stringify(detailObj, null, 2),
            };
        },
        resetForm() {
            this.dialogForm = {
                id: "",
                member_id: "",
                appid: "",
                mchid: "",
                v3SerialNO: "",
                wp_serial: "",
                v3ApiKey: "",
                v3PrivateKeyPem: "",
                v3PrivateKeyPath: "",
                v3PublicKeyPem: "",
                v3PublicKeyPemPath: "",
                v3PlatformCertificatePath: "",
                v3PlatformCertificatePem: "",
                jsonInput: "",
            };
            this.mode = 0;
        },
        onModeChange(mode) {
            if (mode === 0) {
                // 切到表单模式：从JSON解析填充
                const { jsonInput } = this.dialogForm;
                if (jsonInput) {
                    try {
                        const obj = JSON.parse(jsonInput);
                        this.dialogForm.appid = obj.appid || "";
                        this.dialogForm.mchid = obj.mchid || "";
                        this.dialogForm.v3SerialNO = obj.v3SerialNO || "";
                        this.dialogForm.wp_serial =
                            obj.wp_serial || "";
                        this.dialogForm.v3ApiKey = obj.v3ApiKey || "";
                        this.dialogForm.v3PrivateKeyPem =
                            obj.v3PrivateKeyPem || "";
                        this.dialogForm.v3PrivateKeyPath =
                            obj.v3PrivateKeyPath || "";
                        this.dialogForm.v3PublicKeyPem =
                            obj.v3PublicKeyPem || "";
                        this.dialogForm.v3PublicKeyPemPath =
                            obj.v3PublicKeyPemPath || "";
                        this.dialogForm.v3PlatformCertificatePath =
                            obj.v3PlatformCertificatePath || "";
                        this.dialogForm.v3PlatformCertificatePem =
                            obj.v3PlatformCertificatePem || "";
                    } catch (e) {
                        this.$message.error(
                            "JSON解析失败: " + e.message
                        );
                        this.mode = 1;
                    }
                }
            } else {
                // 切到代码模式：从表单字段生成JSON
                const obj = this.buildDetailConfig();
                this.dialogForm.jsonInput = JSON.stringify(obj, null, 2);
            }
        },
        buildDetailConfig() {
            return {
                appid: this.dialogForm.appid,
                mchid: this.dialogForm.mchid,
                v3SerialNO: this.dialogForm.v3SerialNO,
                wp_serial: this.dialogForm.wp_serial,
                v3ApiKey: this.dialogForm.v3ApiKey,
                v3PrivateKeyPem: this.dialogForm.v3PrivateKeyPem,
                v3PrivateKeyPath: this.dialogForm.v3PrivateKeyPath,
                v3PublicKeyPem: this.dialogForm.v3PublicKeyPem,
                v3PublicKeyPemPath: this.dialogForm.v3PublicKeyPemPath,
                v3PlatformCertificatePath: this.dialogForm.v3PlatformCertificatePath,
                v3PlatformCertificatePem: this.dialogForm.v3PlatformCertificatePem,
            };
        },
        async remoteMethod(val) {
            let pType = { 0: "account", 1: "mobile", 2: "dname" };
            let params = {
                page_size: 100,
                [pType[this.memberType]]: val,
            };
            this.selectLoading = true;
            const res = await queryMemberByCondition(params);
            this.selectLoading = false;
            if (res.code != 200) return;
            this.memberList = res.data;
        },
        onClose() {
            this.$emit("update:visible", false);
        },
        onSubmit(formName) {
            if (this.addLoading) return;
            this.$refs[formName].validate(async (valid) => {
                if (!valid) return;

                let detail_config;
                if (this.mode === 0) {
                    detail_config = this.buildDetailConfig();
                } else {
                    try {
                        detail_config = JSON.parse(
                            this.dialogForm.jsonInput
                        );
                    } catch (e) {
                        this.$message.error("JSON解析失败");
                        return;
                    }
                }

                let func = addTransferMerchantConf;
                let params = {
                    member_id: this.dialogForm.member_id,
                    wp_serial: detail_config.wp_serial || this.dialogForm.wp_serial,
                    detail_config,
                    v3PrivateKeyPath: detail_config.v3PrivateKeyPath || "",
                    v3PublicKeyPemPath: detail_config.v3PublicKeyPemPath || "",
                    v3PlatformCertificatePath: detail_config.v3PlatformCertificatePath || "",
                    v3PlatformCertificatePem: detail_config.v3PlatformCertificatePem || "",
                };
                if (this.actionType === "edit") {
                    params.id = this.dialogForm.id;
                    func = updateTransferMerchantConf;
                }

                this.addLoading = true;
                const res = await func(params).catch((e) => {
                    this.addLoading = false;
                });
                this.addLoading = false;
                if (res.code != 200) return;
                this.$message.success(
                    this.actionType === "edit"
                        ? "修改成功"
                        : "新增成功"
                );
                this.onClose();
                this.$emit("refresh");
            });
        },
    },
};
</script>
